import { ReactNode, createContext } from "react";
import useDespesasFotografo, { DespesasFotografoType, CreateDespesasFotografoType, UpdateDespesasFotografoType } from "./hooks/useDespesasFotografo";

interface DespesasFotografoContextProviderProps {
    children: ReactNode;
}

export interface DespesasFotografoContextData {
    getAllDespesasFotografoPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<DespesasFotografoType[] | null>;
    setDespesasFotografo: any;
    despesasFotografo: DespesasFotografoType;
    setListDespesasFotografo: any;
    listDespesasFotografo: DespesasFotografoType[];
    setInitialListDespesasFotografo: any;
    initialListDespesasFotografo: DespesasFotografoType[];
    setDespesasFotografoPageCount: any;
    despesasFotografoPageCount: number;
    createDespesasFotografo: (createDespesasFotografoType: CreateDespesasFotografoType) => Promise<CreateDespesasFotografoType | null>;
    updateDespesasFotografo: (updateDespesasFotografoType: UpdateDespesasFotografoType) => Promise<UpdateDespesasFotografoType | null>;
    deleteDespesasFotografo: (id: number) => Promise<DespesasFotografoType | null>;
    handleGetDespesasFotografoByEmpresaId: (empresaId: number) => Promise<DespesasFotografoType[] | null>;
    listDespesasFotografoByEmpresa: DespesasFotografoType[];
    setListDespesasFotografoByEmpresa: any;
    aprovarDespesasFotografo: (id: number) => Promise<boolean>;
    rejeitarDespesasFotografo: (id: number) => Promise<boolean>;
}

const initialState: DespesasFotografoContextData = {
    getAllDespesasFotografoPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setDespesasFotografo: () => { },
    despesasFotografo: {
        id: 0,
        description: "",
        value: 0,
        date: "",
        observation: "",
        status: 0,
        vendedorId: 0,
        tipoDespesasFotografoId: 0,
        tipoDespesasFotografoName: "",
        tipoDespesasFotografoIcon: "",
    },
    setListDespesasFotografo: () => { },
    listDespesasFotografo: [],
    setInitialListDespesasFotografo: () => { },
    initialListDespesasFotografo: [],
    setDespesasFotografoPageCount: () => { },
    despesasFotografoPageCount: 0,
    createDespesasFotografo: async (createDespesasFotografoType: CreateDespesasFotografoType) => {
        return Promise.resolve(null);
    },
    updateDespesasFotografo: async (updateDespesasFotografoType: UpdateDespesasFotografoType) => {
        return Promise.resolve(null);
    },
    deleteDespesasFotografo: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetDespesasFotografoByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listDespesasFotografoByEmpresa: [],
    setListDespesasFotografoByEmpresa: () => { },
    aprovarDespesasFotografo: async (id: number) => {
        return Promise.resolve(false);
    },
    rejeitarDespesasFotografo: async (id: number) => {
        return Promise.resolve(false);
    },
};

export const DespesasFotografoContext =
    createContext<DespesasFotografoContextData>(initialState);

export default function DespesasFotografoContextProvider({
    children,
}: DespesasFotografoContextProviderProps) {
    const {
        getAllDespesasFotografoPaged,
        createDespesasFotografo,
        updateDespesasFotografo,
        deleteDespesasFotografo,
        despesasFotografo,
        setDespesasFotografo,
        setListDespesasFotografo,
        listDespesasFotografo,
        initialListDespesasFotografo,
        setInitialListDespesasFotografo,
        setDespesasFotografoPageCount,
        despesasFotografoPageCount,
        handleGetDespesasFotografoByEmpresaId,
        listDespesasFotografoByEmpresa,
        setListDespesasFotografoByEmpresa,
        aprovarDespesasFotografo,
        rejeitarDespesasFotografo,
    } = useDespesasFotografo();

    return (
        <DespesasFotografoContext.Provider
            value={{
                getAllDespesasFotografoPaged,
                createDespesasFotografo,
                updateDespesasFotografo,
                deleteDespesasFotografo,
                despesasFotografo,
                setDespesasFotografo,
                setListDespesasFotografo,
                listDespesasFotografo,
                initialListDespesasFotografo,
                setInitialListDespesasFotografo,
                setDespesasFotografoPageCount,
                despesasFotografoPageCount,
                handleGetDespesasFotografoByEmpresaId,
                listDespesasFotografoByEmpresa,
                setListDespesasFotografoByEmpresa,
                aprovarDespesasFotografo,
                rejeitarDespesasFotografo,
            }}
        >
            {children}
        </DespesasFotografoContext.Provider>
    );
}